var map = {
	"./assets/Admin.svg": "e73b",
	"./assets/Advertiser.svg": "15b3",
	"./assets/AnalyticAudience/Green.svg": "3bf8",
	"./assets/AnalyticAudience/Red.svg": "7031",
	"./assets/AnalyticAudience/Yellow.svg": "1a14",
	"./assets/AsideMenu/arrow-collapse-left.svg": "01cc",
	"./assets/AsideMenu/arrow-collapse-right.svg": "decf",
	"./assets/AsideMenu/audit.svg": "c2bd",
	"./assets/AsideMenu/capacity.svg": "4f8f",
	"./assets/AsideMenu/changeManager.svg": "3ec3",
	"./assets/AsideMenu/competition.svg": "6754",
	"./assets/AsideMenu/complaints.svg": "4fe7",
	"./assets/AsideMenu/crm.svg": "4fb7",
	"./assets/AsideMenu/dashboard.svg": "57a7",
	"./assets/AsideMenu/discounts.svg": "06ad6",
	"./assets/AsideMenu/domains.svg": "094d",
	"./assets/AsideMenu/efficiency.svg": "93b1",
	"./assets/AsideMenu/finance.svg": "3313",
	"./assets/AsideMenu/flow.svg": "6598",
	"./assets/AsideMenu/incidence.svg": "f290",
	"./assets/AsideMenu/integrations.svg": "02d7",
	"./assets/AsideMenu/news.svg": "4e97",
	"./assets/AsideMenu/offers.svg": "1642",
	"./assets/AsideMenu/payment-systems.svg": "a616",
	"./assets/AsideMenu/referrals.svg": "cb7b",
	"./assets/AsideMenu/roles.svg": "a58c",
	"./assets/AsideMenu/statistics.svg": "4cd5",
	"./assets/AsideMenu/sub-accounts.svg": "0443",
	"./assets/AsideMenu/support.svg": "a925",
	"./assets/AsideMenu/tools.svg": "1b77",
	"./assets/AsideMenu/users.svg": "c65c",
	"./assets/Auth/advertiser.svg": "62b7",
	"./assets/Auth/main-screen-left.svg": "8196",
	"./assets/Auth/main-screen-right.svg": "9ee1",
	"./assets/Auth/webmaster.svg": "e6fd",
	"./assets/Avatar.svg": "8db2",
	"./assets/CM_logo.svg": "355f",
	"./assets/ChangePassword.svg": "6fdd",
	"./assets/Competition/Raffle/BG-circle.svg": "f2e4",
	"./assets/Competition/Raffle/avatar.svg": "c943",
	"./assets/Competition/Raffle/noto_coin.svg": "8439",
	"./assets/Competition/User.svg": "9e01",
	"./assets/Competition/solar_cup-bold.svg": "9b4c",
	"./assets/Contacts/logo_email.svg": "6df1",
	"./assets/Contacts/logo_skype.svg": "f394",
	"./assets/Contacts/logo_telegram.svg": "ea99",
	"./assets/Contacts/logo_viber.svg": "7206",
	"./assets/Contacts/logo_whatsApp.svg": "8054",
	"./assets/Dashboard/commission.svg": "fc02",
	"./assets/Dashboard/competition/BronzeCup.svg": "3b91",
	"./assets/Dashboard/competition/GoldenCup.svg": "742c",
	"./assets/Dashboard/competition/SilverCup.svg": "d887",
	"./assets/Dashboard/competition/ticket.svg": "caf9",
	"./assets/Modal/not-available.svg": "2aa8",
	"./assets/NavigationBar/refresh.svg": "0e21",
	"./assets/NavigationBar/socials/dark.svg": "c777",
	"./assets/NavigationBar/socials/facebook.svg": "1825",
	"./assets/NavigationBar/socials/instagram.svg": "6e54",
	"./assets/NavigationBar/socials/light.svg": "9512",
	"./assets/NavigationBar/socials/linkedin.svg": "b044",
	"./assets/NavigationBar/socials/socials.svg": "27eb",
	"./assets/NavigationBar/socials/telegram-bot.svg": "4bdb",
	"./assets/NavigationBar/socials/telegram.svg": "2209",
	"./assets/NavigationBar/socials/vk.svg": "17ef",
	"./assets/Notepad.svg": "df8e",
	"./assets/Offer/Clone.svg": "d94b",
	"./assets/Offer/OfferImg.svg": "2fc1",
	"./assets/Offer/OfferPage.svg": "8f63",
	"./assets/Offer/dislike.svg": "1f44",
	"./assets/Offer/gridicons_stats-down.svg": "f8b6",
	"./assets/Offer/like.svg": "df0f",
	"./assets/Offer/request.svg": "ea4d",
	"./assets/Referrals/Empty.svg": "0e84",
	"./assets/Referrals/ReferralLink.svg": "5395",
	"./assets/Table/arrowStatus.svg": "c2ee",
	"./assets/UploadAvatar/arrow-rotate.svg": "ce4f",
	"./assets/UploadAvatar/upload-file.svg": "e3b1",
	"./assets/Web.svg": "f046",
	"./assets/WebmasterCardProfile/Managers.svg": "9bcb",
	"./assets/WebmasterCardProfile/Referrer.svg": "fa48",
	"./assets/WebmasterCardProfile/SubAccount.svg": "89c9",
	"./assets/WebmasterCardProfile/Team.svg": "c67b",
	"./assets/WebmasterCardProfile/viber.svg": "cf4d",
	"./assets/common/canceled.svg": "d11a",
	"./assets/common/copy.svg": "66f0",
	"./assets/common/dislike.svg": "4437",
	"./assets/common/gambling.svg": "6e44",
	"./assets/common/hold.svg": "5dc0",
	"./assets/common/like.svg": "6d89",
	"./assets/common/nutra.svg": "1680",
	"./assets/common/success.svg": "a823",
	"./assets/components/schedule.svg": "3203",
	"./assets/file-download.svg": "082a",
	"./assets/logo-square.svg": "1532",
	"./assets/logo.svg": "9b19",
	"./assets/logoLight.svg": "a149",
	"./assets/logoList.svg": "92c0",
	"./assets/logo_dark.svg": "5d85",
	"./assets/logout.svg": "309a",
	"./assets/update-photo.svg": "2ffa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa53";